import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Backdrop,
  CircularProgress,
  makeStyles,
  Grid,
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useNavigate } from "react-router-dom";
// estilos
import { useStylesApp } from "../../hooks/useStyles";
import { palette } from "configurations/styles/theme";
import validations from "./validations";
import { useDispatch } from "react-redux";
import { authUserSuccess, parseJwt } from "redux/actions/userActions";
import { getTkTmp, removeTKTmp } from "redux/sessionstorage";
import { sessionTimeOut } from "security/services";
import middleware from "configurations/axios";
import Alert from "widgets/alert";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  tituloClave: {
    textAlign: "center",
    fontSize: "16px",
  },
}));

export default function DialogChangePass({ openDialog, closeDialog, onClose }) {
  const classes = useStylesApp();
  const [open, setOpen] = useState(openDialog);
  const classesView = useStyles();
  const history = useNavigate();

  const [currentPass, setCurrentPass] = useState("");
  const [pass, setPass] = useState("");
  const [passConfirm, setPassConfirm] = useState("");
  const [errores, setErrores] = useState({});
  const [openLoader, setOpenLoader] = useState(false);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const dispatch = useDispatch();
  const authSuccess = (data) => dispatch(authUserSuccess(data));
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showPassConfirm, setShowPassConfirm] = useState(false);

  const passMismatch = useMemo(() => {
    if (!pass || !passConfirm) return false;
    return pass !== passConfirm;
  }, [pass, passConfirm]);

  useEffect(() => {
    setOpen(openDialog);

    setMsg({ show: false, msg: null, type: null });

    setCurrentPass("");
    setPass("");
    setPassConfirm("");

    setErrores({});

    setShowCurrentPass(false);
    setShowPass(false);
    setShowPassConfirm(false);

    return () => setOpen(false);
  }, [openDialog]);

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleClose = () => {
    setOpen(false);

    closeDialog(false);
    onClose(false);
  };

  const handleChange = (event) => {
    if (event.target.name === "pass") {
      setPass(event.target.value);
      setErrores((prev) => ({ ...prev, confirmPass: undefined }));
    } else if (event.target.name === "passConfirm") {
      setPassConfirm(event.target.value);
      setErrores((prev) => ({ ...prev, confirmPass: undefined }));
    } else if (event.target.name === "currentPass") {
      setCurrentPass(event.target.value);
    }
  };

  const updatePass = async () => {
    const errors = validations.updatePassword({
      currentPass: currentPass,
      newPass: pass,
      confirmPass: passConfirm,
    });
    if (pass && passConfirm && pass !== passConfirm) {
      errors.confirmPass = "Las contraseñas no coinciden.";
    }

    setErrores(errors);

    if (Object.keys(errors).length === 0) {
      const objAuth = getTkTmp();
      const tk = objAuth.accessToken;

      const timeout = sessionTimeOut(parseJwt(tk).exp);

      authSuccess(objAuth);

      if (timeout >= 360000) {
        setOpenLoader(true);

        await middleware
          .put("/cuenta/usuario/contrasenia", {
            claveActual: currentPass,
            idAsignacionEmpresaUsuario: parseJwt(tk).sub,
            idEmpresa: parseJwt(tk).ruc,
            nuevaClave: pass,
          })
          .then((response) => {
            if (response.status >= 200 && response.status <= 300) {
              removeTKTmp();
              history("/modulos");
            }

            setOpenLoader(false);
            onClose(false);
          })
          .catch((exception) => {
            if (exception.response) {
              if (exception.response.status === 400) {
                setMsg({
                  show: true,
                  msg: "No se pudo actualizar la contraseña.",
                  type: "error",
                });
              } else if (exception.response.status === 401) {
                setMsg({
                  show: true,
                  msg: "Error de autenticación.",
                  type: "error",
                });
              } else if (exception.response.status === 405) {
                setMsg({
                  show: true,
                  msg: "La contraseña actual enviada no coincide con los registros.",
                  type: "error",
                });
              } else {
                setMsg({
                  show: true,
                  msg: "No se pudo actualizar la contraseña.",
                  type: "error",
                });
              }
            } else {
              setMsg({
                show: true,
                msg: "Existen problemas en la red. Contáctese con el administrador del Sistema.",
                type: "error",
              });
            }

            setOpenLoader(false);
          });
      } else {
        setMsg({
          show: true,
          msg: "La sesión expiro, vuelva a la pantalla de Login.",
          type: "error",
        });
      }
    }
  };

  const handleStyle = (error, value) => {
    if (value) {
      if (error) {
        return "form-control is-invalid";
      } else {
        return "form-control is-valid";
      }
    } else {
      return "form-control";
    }
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby="primer logeo"
    >
      <DialogTitle>
        <h6>Cambie su contraseña</h6>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 alert alert-primary">
                <Grid
                  container
                  justify="center"
                  className={classesView.tituloClave}
                >
                  <Grid item xs={12}>
                    <strong>
                      Bienvenido al Sistema de Facturación Electrónica, Facturar
                      PA
                    </strong>
                  </Grid>
                </Grid>

                <strong>
                  Al ser su primer inicio de sesión o recuperar su contraseña,
                  debe actualizar la misma.
                </strong>

                <br />

                <strong>Recuerde:</strong>

                <ul>
                  <li>La nueva contraseña debe tener al menos 8 caracteres</li>
                  <li>Debe tener mayúscula, minúscula y carácter especial</li>
                </ul>
              </div>

              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}

              {/* CONTRASEÑA ACTUAL */}
              <div className="col-sm-12 mb-3">
                <TextField
                  className={handleStyle(errores.currentPass, currentPass)}
                  label="Contraseña actual"
                  fullWidth
                  type={showCurrentPass ? "text" : "password"}
                  name="currentPass"
                  value={currentPass}
                  onChange={handleChange}
                  variant="outlined"
                  error={Boolean(errores.currentPass)}
                  helperText={errores.currentPass}
                  FormHelperTextProps={{
                    style: { fontSize: "12px" },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowCurrentPass(!showCurrentPass)}
                          edge="end"
                        >
                          {showCurrentPass ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              {/* NUEVA CONTRASEÑA */}
              <div className="col-sm-12 mb-3">
                <TextField
                  className={handleStyle(errores.newPass, pass)}
                  label="Nueva contraseña"
                  fullWidth
                  type={showPass ? "text" : "password"}
                  name="pass"
                  value={pass}
                  onChange={handleChange}
                  variant="outlined"
                  // opcional: marcar también en nueva contraseña cuando no coinciden
                  error={Boolean(errores.newPass) || passMismatch}
                  helperText={
                    errores.newPass ||
                    (passMismatch ? "Las contraseñas no coinciden." : "")
                  }
                  FormHelperTextProps={{
                    style: { fontSize: "12px" },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPass(!showPass)}
                          edge="end"
                        >
                          {showPass ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              {/* CONFIRMAR CONTRASEÑA */}
              <div className="col-sm-12 mb-3">
                <TextField
                  className={handleStyle(
                    errores.confirmPass || passMismatch,
                    passConfirm,
                  )}
                  label="Confirmar contraseña"
                  fullWidth
                  type={showPassConfirm ? "text" : "password"}
                  name="passConfirm"
                  value={passConfirm}
                  onChange={handleChange}
                  variant="outlined"
                  error={Boolean(errores.confirmPass) || passMismatch}
                  helperText={errores.confirmPass}
                  FormHelperTextProps={{
                    style: { fontSize: "12px" },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassConfirm(!showPassConfirm)}
                          edge="end"
                        >
                          {showPassConfirm ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div className="col-sm-6">
                <Button
                  onClick={updatePass}
                  color="primary"
                  variant="contained"
                  fullWidth
                >
                  Cambiar Contraseña
                </Button>
              </div>

              <div className="col-sm-6">
                <Button
                  onClick={handleClose}
                  color="secondary"
                  variant="outlined"
                  fullWidth
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>

      <Backdrop className={classesView.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
